import {
  Button,
  Flex,
  Icon,
  Box,
  useTheme,
  ButtonProps,
  BoxProps,
  Tooltip,
} from '@wegroup/design-system';
import React from 'react';
import { mq } from '../../../../common/src/utils/styledComponentsUtils';
import Blur from '../../../../design-system/src/content/components/Blur';

interface Props {
  onLeftClick: () => void;
  onRightClick: () => void;
  leftHoverText?: string;
  rightHoverText?: string;
  enabled?: boolean;
  showBlur?: boolean;
  buttonsDisabled?: boolean;
}

const SingleOfferCarousel: React.FC<React.PropsWithChildren<Props>> = ({
  onLeftClick,
  onRightClick,
  leftHoverText,
  rightHoverText,
  enabled = true,
  showBlur = false,
  buttonsDisabled = false,
  children,
}) => {
  const { space } = useTheme();

  const handleOnLeftClick = () => {
    onLeftClick();
  };

  const handleOnRightClick = () => {
    onRightClick();
  };

  if (!enabled) return <>{children}</>;

  return (
    <Flex
      position="relative"
      align="center"
      mt="6"
      mx={{ base: '4', laptopL: 0 }}
    >
      <CarouselButton
        label={leftHoverText}
        position="absolute"
        sx={{
          right: `calc(100% - ${space[6]})`,
          [mq.custom(1600)]: {
            right: `calc(100% + ${space[6]})`,
          },
        }}
        onClick={handleOnLeftClick}
        disabled={buttonsDisabled}
      >
        <Icon name="GeneralActionsArrowLeft" />
      </CarouselButton>
      <Box w="100%">
        <Box
          zIndex={2}
          position="absolute"
          left={0}
          top={0}
          right={0}
          bottom={0}
          pointerEvents="none"
        >
          <Blur show={showBlur} borderRadius="md" />
        </Box>

        <FakeOffer left="6" right="6" bottom="6" top="-6" />
        <FakeOffer left="3" right="3" bottom="3" top="-3" />

        {children}
      </Box>
      <CarouselButton
        label={rightHoverText}
        position="absolute"
        sx={{
          left: `calc(100% - ${space[6]})`,
          [mq.custom(1600)]: {
            left: `calc(100% + ${space[6]})`,
          },
        }}
        onClick={handleOnRightClick}
        disabled={buttonsDisabled}
      >
        <Icon name="GeneralActionsArrowRight" />
      </CarouselButton>
    </Flex>
  );
};

interface CarourselButtonProps {
  label?: string;
}

const CarouselButton: React.FC<
  React.PropsWithChildren<CarourselButtonProps & ButtonProps>
> = ({ label, children, ...props }) => {
  return (
    <Tooltip label={label}>
      <Button
        variant="secondary"
        borderRadius="full"
        p="3"
        w="12"
        h="12"
        {...props}
        zIndex={3}
        boxShadow="level2"
      >
        {children}
      </Button>
    </Tooltip>
  );
};

const FakeOffer: React.FC<React.PropsWithChildren<BoxProps>> = ({
  ...props
}) => {
  return (
    <Box
      zIndex={0}
      position="absolute"
      boxShadow="level2"
      opacity="0.8"
      bg="white"
      border="1px"
      borderColor="gray.50"
      borderRadius="md"
      {...props}
    />
  );
};

export default SingleOfferCarousel;
